import React, { useEffect } from "react";
import { Container, Paper, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useAppState } from "../application/AppState";
import { setLanguage } from "../application/actions";
import MyPage from "./MyPage";
import LoginAssently from "./Login/LoginAssently";
import LoginTest from "./Login/LoginTest"; // Optional: use this for test login

const useStyles = makeStyles(() => ({
    boxWrapper: {
        marginBottom: "55px",
        minHeight: "calc(100vh - 492px)",
        display: "flex",
        flexDirection: "column",
    },
    container: {
        position: "relative",
        zIndex: 1100,
        marginTop: "-95px",
        marginBottom: "45px",
    },
}), { name: "Main" });

const Main = () => {
    const classes = useStyles();
    const [{ isAuthenticated }, dispatch] = useAppState();

    useEffect(() => {
        const path = window.location.pathname.replace(/\//g, '');
        const langMap = { no: "no", dk: "dk" };
        const languageCode = langMap[path] || "sv";

        dispatch(setLanguage(languageCode));
    }, [dispatch]);

    return (
        <Box component="main" role="main" className={classes.boxWrapper}>
            <Container maxWidth="md" className={classes.container}>
                <Paper elevation={5}>
                    {isAuthenticated ? <MyPage /> : <LoginAssently />}
                      {/* {isAuthenticated ? <MyPage /> : <LoginTest />}*/}
                    
                </Paper>
            </Container>
        </Box>
    );
};

export default Main;
